import Footer from "../components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

      <p className="mb-4">
        At <strong>Bill-lex.com</strong>, a product of{" "}
        <strong>Lexora Technologies OPC Private Limited</strong>, we value the
        trust of our users and are committed to protecting your privacy. This
        Privacy Policy explains how we collect, use, and safeguard your
        information when you use our services.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        1. Information We Collect
      </h2>
      <ul className="list-disc ml-6 mb-4">
        <li>
          Business information (store name, contact info, GSTIN if applicable)
        </li>
        <li>User information (name, email, phone number)</li>
        <li>Billing and invoicing data</li>
        <li>Inventory and sales data uploaded or generated by your business</li>
        <li>Payment-related data through our partner Cashfree</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        2. How We Use Your Information
      </h2>
      <ul className="list-disc ml-6 mb-4">
        <li>To generate invoices and manage stock & inventory</li>
        <li>To process payments via secure integration with Cashfree</li>
        <li>
          To analyze your data for reports and analytics within your account
        </li>
        <li>To improve our services and provide customer support</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        3. Data Sharing & Compliance
      </h2>
      <p className="mb-4">
        We do <strong>not sell</strong> your personal or business data to any
        third parties. Payment information is handled securely and in compliance
        with
        <strong>
          {" "}
          Cashfree's policies and applicable financial regulations
        </strong>
        . We may share limited data with service providers involved in
        infrastructure, support, or analytics — but only as needed and with
        confidentiality agreements in place.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        4. Prohibited Activities
      </h2>
      <p className="mb-4">
        We strictly{" "}
        <strong>
          prohibit the use of Bill-lex.com for any illegal, adult, or unlawful
          purposes
        </strong>
        , including but not limited to:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Adult content or pornography</li>
        <li>Illegal drug sales or distribution</li>
        <li>Gambling or unauthorized lotteries</li>
        <li>Money laundering or fraudulent billing activity</li>
        <li>
          Any activity that violates the laws of India or your local
          jurisdiction
        </li>
      </ul>
      <p className="mb-4">
        Any account found in violation will be terminated immediately, and
        appropriate action will be taken as per law and our compliance partners'
        terms (including Cashfree).
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">5. Data Security</h2>
      <p className="mb-4">
        We use industry-standard security practices to protect your data,
        including encryption, secure API endpoints, and access controls.
        However, no method of transmission over the Internet is 100% secure, and
        we cannot guarantee absolute security.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">6. Your Rights</h2>
      <p className="mb-4">
        You may access, update, or request deletion of your data by contacting
        our support team. We comply with relevant Indian data protection laws
        regarding user rights and consent.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        7. Changes to This Policy
      </h2>
      <p className="mb-4">
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page, and continued use of the platform implies
        acceptance of the updated policy.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">8. Contact Us</h2>
      <p className="mb-4">
        For questions regarding this policy or your data, please contact us at{" "}
        <a
          href="mailto:billlex.owner@gmail.com"
          className="text-blue-600 underline"
        >
          billlex.owner@gmail.com
        </a>
        .
      </p>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
